// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071343/js/" + chunkId + "." + {"44":"9ca2342b","225":"5301c83f","481":"75ca8baa","486":"1471de9f","770":"34dd6693"}[chunkId] + ".0.41627031312591156.chunk.js";
};